import * as h2Api from '../h2Api'

export const RESET_PASSWORD = 'RESET_PASSWORD'

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET'

export const FORGOT_USERNAME = 'FORGOT_USERNAME'

export const RESET_PASSWORD_CHANGE_FIELD = 'RESET_PASSWORD_CHANGE_FIELD'

export const RESET_PASSWORD_RESET_FORM = 'RESET_PASSWORD_RESET_FORM'

export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'

export const resetPassword = form => dispatch => {
  return dispatch(
    h2Api.post(
      '/user/password',
      form
    )({ type: RESET_PASSWORD, error: 'Password reset failed' })
  )
}

export const requestPasswordReset = form => {
  return h2Api.post('/user/request/passwordreset', form)({ type: REQUEST_PASSWORD_RESET })
}

export const requestUsernameLookup = form => {
  return h2Api.post('/user/request/usernamelookup', form)({ type: FORGOT_USERNAME })
}
